module.exports = __webpack_public_path__ + "img/web.b54f6e9f.svg";